import { getRequestTitle } from '../Request.utils'

export function getServiceRequestListItemProps(value) {
  return {
    building: value.building?.title,
    flat: value.flat?.number,
    isArchived: value.archived,
    owner: {
      fullname: value.owner?.fullname,
      role: value.owner?.role,
    },
    status: value.status_id,
    text: getRequestTitle({
      requestNumber: value.request_no,
      title: value.title,
    }),
    value: value.id,
  }
}
